import React, { FC, useContext, useEffect } from "react";

import { Alert, Box, CloseButton } from "@chakra-ui/react";
import { AlertNotificationWithIdType } from "@mtb/mtb-core";
import { AlertsAPIContext } from "../AlertsContext";

export const AlertNotification: FC<AlertNotificationWithIdType> = ({
  duration,
  type,
  title,
  description,
  id,
}) => {
  const { removeAlert } = useContext(AlertsAPIContext);

  const handleRemoveAlert = () => removeAlert(id);
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        handleRemoveAlert();
        return () => clearTimeout(timer);
      }, duration);
    }

    // eslint-disable-next-line
  }, []);

  return (
    <Alert.Root status={type} m="3" variant="outline" width="auto">
      <Alert.Indicator />
      <Box flex="1">
        <Alert.Title mr={2}>{title}</Alert.Title>
        <Alert.Description mr={8}>{description}</Alert.Description>
      </Box>
      <CloseButton
        position="absolute"
        right="8px"
        top="8px"
        onClick={handleRemoveAlert}
      />
    </Alert.Root>
  );
};
